<!-- https://stackoverflow.com/questions/60678840/vuetify-image-upload-preview -->
<!-- in case we want a toggle open all : https://www.codeply.com/p/ys4Df2OLiE -->
<template>
  <div>
    <v-card class="ma-10">
      <v-card-title class="font-weight-light display-2 text-uppercase">
        Value Tables
      </v-card-title>
      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="search"
            label="Search ..."
            class="mx-4"
            append-icon="mdi-magnify"
          ></v-text-field>
        </v-col>

        <v-col class="pt-6">
          <v-btn
            @click="
              overlay = !overlay;
              addType = 'mainCat';
            "
            class="light"
            elevation="1"
            color="green lighten-2"
          >
            Add Category
          </v-btn>
          <v-btn
            @click="
              overlay = !overlay;
              addType = 'subCat';
            "
            class="ml-4"
            elevation="1"
            color="green lighten-3"
          >
            Add Subcategory
          </v-btn>

          <v-overlay :value="overlay">
            <v-sheet
              class="px-7 pt-7 ma-4 pb-4 mx-auto text-center d-inline-block"
              color="blue-grey darken-3"
              :rounded="true"
              dark
            >
              <v-form v-if="addType === 'mainCat'">
                <h2 class="font-weight-thin">Create a New Category</h2>
                <v-text-field
                  label="Category Name"
                  placeholder=""
                  v-model="newMainCatItem['name']"
                ></v-text-field>
                <v-file-input
                  truncate-length="15"
                  accept="image/*"
                  prepend-icon="mdi-camera"
                  v-model="newMainCatItem['newMainCatImg']"
                ></v-file-input>
                <v-btn class="ma-1" color="" plain @click="overlay = false"
                  >Cancel
                </v-btn>
                <v-btn
                  class="ma-1"
                  color="success"
                  @click="save(newMainCatItem, 'newMain')"
                  >Create</v-btn
                >
              </v-form>

              <v-form v-else-if="addType === 'subCat'">
                <h2 class="font-weight-thin">Create a New Subcategory</h2>
                <v-text-field
                  label="Subcategory Name"
                  placeholder=""
                  v-model="newSubCatItem['newSubCatName']"
                >
                </v-text-field>
                <v-select
                  label="Which Main Category?"
                  placeholder=""
                  :items="mainCats"
                  item-text="name"
                  item-value="ID"
                  v-model="newSubCatItem['newMainCat']"
                >
                </v-select>
                <v-select
                  label="Unit"
                  placeholder=""
                  :items="unitOptions"
                  v-model="newSubCatItem['newUnit']"
                >
                </v-select>
                <v-text-field
                  label="Price"
                  placeholder=""
                  v-model="newSubCatItem['newPrice']"
                >
                </v-text-field>
                <v-file-input
                  truncate-length="15"
                  accept="image/*"
                  prepend-icon="mdi-camera"
                  v-model="newSubCatItem['newSubCatImg']"
                ></v-file-input>
                <v-btn class="ma-1" color="grey" plain @click="overlay = false">
                  Cancel
                </v-btn>

                <v-btn
                  class="ma-1"
                  color="success"
                  plain
                  @click="save(newSubCatItem, 'newSub')"
                >
                  Create
                </v-btn>
              </v-form>
            </v-sheet>
          </v-overlay>
        </v-col>
      </v-row>

      <div id="app">
        <v-app id="inspire">
          <v-data-table
            :headers="headers"
            :items="materials"
            item-text="text"
            item-value="key"
            :search="search"
            group-by="CatName"
            class="elevation-1"
            :items-per-page="20"
            :loading="stillLoading"
            loading-text="Loading... Please wait"
            id="cats"
          >
            <template v-slot:item="{ item }">
              <tr>
                <!-- all the content -->
                <td v-for="(header, key) in headers" :key="key">
                  <v-edit-dialog
                    v-if="header.type === 'text'"
                    :return-value.sync="item[header.value]"
                    :key="item['subCatID']"
                    @save="save(item, 'update')"
                    dark
                  >
                    {{ item[header.value] }}
                    <template v-slot:input>
                      <!--  for text inputs-->
                      <v-text-field
                        v-model="item[header.value]"
                        label="Edit"
                        @save="save(item, 'update')"
                        single-line
                        dark
                      >
                      </v-text-field>
                    </template>
                  </v-edit-dialog>

                  <v-autocomplete
                    v-else-if="header.type === 'select'"
                    v-model="item[header.value]"
                    :key="item['subCatID']"
                    @input="save(item, 'update')"
                    :items="header.options"
                    rounded
                    background-color="teal lighten-4"
                  >
                    {{ item[header.value] }}
                  </v-autocomplete>
                  <!--                   <v-simple-checkbox
                    v-else-if="header.type === 'check'"
                    v-model="item[header.value]"
                    :key="item['subCatID']"
                    @save="save(item, 'update')"
                    :ripple="false"
                  >
                    {{ item[header.value] }}
                  </v-simple-checkbox>
 -->
                  <v-img
                    contain
                    v-else-if="header.type === 'image'"
                    v-bind:src="
                      $store.state.pathDepth +
                      'photos/defaultPics/' +
                      item['SubCatName'] +
                      '.png' +
                      '?rnd=' +
                      cacheKey
                    "
                    :key="item['subCatID']"
                    max-height="100"
                    max-width="100"
                    class="ma-4"
                  />

                  <div v-else-if="header.type === 'upload'">
                    <v-row>
                      <v-file-input
                        truncate-length="15"
                        accept="image/*"
                        prepend-icon="mdi-camera"
                        v-model="item[header.value]"
                      ></v-file-input>
                      <v-btn
                        color="blue-grey"
                        class="ma-2 white--text"
                        v-on:click="uploadFile(item['subCatID'])"
                      >
                        Upload
                        <v-icon right dark> mdi-cloud-upload </v-icon>
                      </v-btn>
                    </v-row>
                  </div>

                  <!-- <td class="d-block d-sm-table-cell" v-for="field in Object.keys(item)" :key="field"> -->
                  <!-- {{item[field]}} -->
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-app>
      </div>
    </v-card>
    <div>
      <v-snackbar type="success" :value="alert" transition="fade-transition">
        User updated successfully
      </v-snackbar>
    </div>
  </div>
</template>

<style>
#cats table thead {
  background: #e57373;
  font-size: 50px !important;
}
table.v-table thead th {
  font-size: 40px !important;
}

.v-select {
  padding-left: 3px;
  /*background: green;*/
}
</style>

<script>
export default {
  methods: {
    fetchAll: function () {
      this.$api
        .post(this.$store.state.pathDepth + "sessions_check.php", {})
        .then((response) => {
          this.session = response.data;
          console.log(this.session);
          this.$api
            .post(
              this.$store.state.pathDepth + "material_query.php",
              this.session
            )
            .then((response) => {
              this.materials = response.data;
              this.stillLoading = false;
            });
        });
    },

    save(item, type) {
      var vm = this;
      console.log(item);
      this.$api
        .post(this.$store.state.pathDepth + "material_update.php", {
          info: item,
          type: type,
          session: vm.session,
        })
        .then((response) => {
          setTimeout(function () {
            console.log(response.data);
          }, 500);
          vm.alert = true;
          setTimeout(function () {
            vm.alert = false;
          }, 2000);
          // turn off the overlay
          this.overlay = false;
          // clean up the submitted item
          this.newSubCatItem = {
            newSubCatName: "",
            newMainCat: "",
            newPrice: "",
            newUnit: "",
            newSubCatImg: "",
          };
        });
      if (type === "newMain" || type === "newSub") {
        vm.fetchAll();
      }
    },

    uploadFile: function (subCatID) {
      console.log(subCatID);
      let currMaterial = this.materials.find(
        (obj) => obj.subCatID === subCatID
      );

      // currMaterial.image.name =  "subcat_"+subCatID + currMaterial.image.name.split('.').pop();
      // console.log(currMaterial.image.name)

      let formData = new FormData();
      let newFilename =
        "subcat_" + subCatID + "." + currMaterial.image.name.split(".").pop();
      formData.append("file", currMaterial.image, newFilename);
      console.log(formData);
      this.$api
        .post(this.$store.state.pathDepth + "ajaxfile.php", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (response) {
          if (!response.data) {
            alert("File not uploaded.");
          } else {
            // alert('File uploaded successfully.');
            // }, 1 * 1000)
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      this.cacheKey = Date.now();
      console.log(this.cacheKey);
    },
    fetchTranslations: function () {
      this.$api
        .get(this.$store.state.pathDepth + "lang/categories.json")
        .then((response) => {
          //   // console.log(response);
          this.catTranslations = response.data;
        });
    },
    // applyTranslations: function () {
    //   // $vm = this;
    //   this.materials.map((e) => {
    //     var newObj = e;

    //     this.materials.e.key = e;
    //     console.log(e);
    //     this.materials.e.text = this.catTranslations.categories[e.CatName];
    //   }, this);
    // },

    getCookie: function (name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
    },
  },

  created: function () {
    this.userLang = this.getCookie("recup_lang");
    this.fetchTranslations();
    this.fetchAll();
    this.applyTranslations();
  },
  computed: {
    mainCats: function () {
      // ugly js one-liner to return array of unique main cat + ID names
      var unique = Array.from(
        new Set(
          this.materials
            .map((item) => [item.CatName, item.ID])
            .map(JSON.stringify)
        ),
        JSON.parse
      );
      unique = unique.map(function (x) {
        return {
          name: x[0],
          ID: x[1],
        };
      });

      return unique;
    },
  },

  watch: {},
  data() {
    return {
      search: "",
      test: "sdfsdf",
      catTranslations: null,
      stillLoading: true,
      alert: false,
      files: {},
      overlay: false,
      file: "",
      cacheKey: 1,
      headers: [
        {
          text: "Subcategory Name",
          value: "SubCatName",
          type: "text",
        },
        {
          text: "Sales Unit",
          value: "Unit",
          type: "select",
          options: ["kg", "pc"],
        },
        {
          text: "Price/unit",
          value: "Price",
          type: "text",
        },
        {
          text: "Image",
          value: "st",
          type: "image",
        },

        {
          text: "Default Image",
          value: "image",
          type: "upload",
        },
      ],
      newSubCatItem: {
        newSubCatName: "",
        newMainCat: "",
        newPrice: "",
        newUnit: "",
        newSubCatImg: "",
      },
      newMainCatItem: {
        newMainCatName: "",
        newMainCatImg: "",
      },
      addType: "",
      unitOptions: ["kg", "pc"],
      materials: [],
      orgs: [],
      holder: [],
    };
  },
};
</script>
